import React from 'react';

// Components
import { Typography } from '../Typography';
import { MainButton } from '../../inputs/buttons/MainButton';
import { AlertIcon } from '../../../assets/icons/AlertIcon';

// Components Styled
import { Content, IconWrap, Title, Detail } from './styles';

export interface ErrorPanelProps {
  /** Titular, ya traducido. */
  title: string;
  /** Frase de apoyo, ya traducida. Se omite en el 404: ahí sobra. */
  message?: string;
  /** Motivo técnico del fallo (`statusText`/`message`). Nunca en un 404. */
  detail?: string;
  /** Texto del botón, ya traducido. */
  actionLabel: string;
  onAction: () => void;
}

/**
 * La caja que cuenta qué ha pasado y ofrece la salida.
 *
 * Vive aparte de sus dos llamadores porque son dos MARCOS distintos —la
 * pantalla suelta del `errorElement` y el 404 de dentro de la aplicación— con
 * el mismo contenido. Sin esto, el día que cambie el texto o el botón habría
 * que acordarse de tocar los dos sitios.
 */
export function ErrorPanel({
  title,
  message,
  detail,
  actionLabel,
  onAction,
}: ErrorPanelProps): JSX.Element {
  return (
    <Content>
      <IconWrap aria-hidden>
        <AlertIcon />
      </IconWrap>
      <Title
        component="h1"
        size="XL"
        variant="semiBold"
        colorText="greyVeryDark"
      >
        {title}
      </Title>
      {(message || detail) && (
        <Detail>
          {message && <Typography size="L">{message}</Typography>}
          {detail && (
            <Typography colorText="greyDark">
              <i>{detail}</i>
            </Typography>
          )}
        </Detail>
      )}
      <MainButton text={actionLabel} onClick={onAction} />
    </Content>
  );
}

export default ErrorPanel;
